import { storeStructure } from '../store/reducers';
import routes from '../routes/route';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';
import tableMediaReferences from './tableMediaReferences';

export default {
  attributeName: storeStructure.VoD,
  isDragable: false,
  canOpen: true,
  canEdit: true,
  canCreate: false,
  canRemove: true,
  createPath: routes.VOD_NEW,
  editURL: routes.VOD_EDIT,
  emptyMessage: "You don't have VoD jobs, click on the +new button to make a new one.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '12rem',
      helpText: 'Name of VoD Job in process or processed.',
      canOrder: true,
      canFilter: true,
    },
    {
      attributeName: 'outputFile',
      label: '1st Output',
      helpText: 'URL of the first output file, you can see more output URLs on the VoD detail page.',
      width: '20rem',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canOrder: true,
      canFilter: true,
    },
    {
      attributeName: 'status',
      label: 'Status',
      helpText: 'Status of VoD job.',
      type: FormInputTypes.STATUS,
      secondaryValue: 'log',
      // width: '10rem',
      exactWidth:'100px',
      colors: {
        preparing: 'bg-warning',
        enqueued: 'bg-info',
        processing: 'bg-info',
        success: 'bg-success',
        error: 'bg-danger',
        fatal: 'bg-danger',
      },
    },
    {
      attributeName: 'created_at',
      label: 'Created At',
      width: '12rem',
      helpText: 'Date of VoD job creation.',
      type: FormInputTypes.TIMESTAMP,
      canOrder: true,
      exactWidth:'250px',
    },
    {
      attributeName: 'more',
      label: 'More',
      width: '4rem',
      helpText: 'More information about the VoD.',
      type: FormInputTypes.MORE,
      exactWidth:'50px',
    },
    {
      attributeName: 'id',    
      label: 'Linked to medias',
      type: FormInputTypes.BUTTON_POPUP,
      iconSize:'2x',
      icon: IconType.LINK,
      helpText: 'open list of Media references',
      canOrder: false,      
      canFilter: false,
      exactWidth:'100px',
      openUrl:'vodReferences',
      enabledWhen:{"field":"noRef","values":"1"},
      formConfig:
      {
        title: 'VOD References',
        description:'This vod is referenced by the following Medias:',
        type: FormInputTypes.TABLE,
        fields: [
          {
            attributeName: 'mediaReferences',
            type: FormInputTypes.TABLE,
            label: '',
            helpText: '',
            configFile: tableMediaReferences
          }
        ]
        
      },
      
    },
    {
      attributeName: 'noRef',
      label: 'Number of References',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Name of composed experience',
      default: '0',      
      hidden: true
    },
  ],
};
